import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../boot";

export const getTages = createAsyncThunk("utils/tag-list", async (payload) => {
  try {
    const response = await axios.post(`${baseUrl}utils/api/v1/tag-list`);
    console.log("this is respinse o tage ", response);
    return response;
  } catch (error) {
    throw error;
  }
});
